import React, { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FirebaseContext } from "../contexts/FirebaseContext";
import TaskItem from "../components/TaskItem";
import { handleWipClick } from "../utils/handleWipClick";
import { handleToggleTracking } from "../utils/handleToggleTracking";
import styles from "../styles/WipScreenStyles";

const WipScreen = () => {
  const navigate = useNavigate();
  const {
    wipTasks,
    labels,
    startCollectingWipTasks,
    setTaskState,
    completeTask,
    setTaskTrackingState,
    updateRecordingTaskInFirestore,
  } = useContext(FirebaseContext);
  const hasStartedCollection = useRef(false);

  useEffect(() => {
    if (!hasStartedCollection.current && wipTasks.length === 0) {
      startCollectingWipTasks();
      hasStartedCollection.current = true;
    }
  }, [startCollectingWipTasks, wipTasks]);

  const handleTaskClick = (task) => {
    navigate(`/taskDetail/${task.id}`);
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Work In Progress Tasks</h1>
      <div style={styles.taskList}>
        {wipTasks.length > 0 ? (
          wipTasks.map((task) => (
            <div key={task.id} style={styles.taskItemContainer}>
              <TaskItem
                task={task}
                labels={labels}
                onClick={() => handleTaskClick(task)}
                onToggleDone={() =>
                  task.taskState === "task_state_done"
                    ? setTaskState(task.id, "task_state_backlog")
                    : completeTask(task)
                }
                onWipClick={() => handleWipClick(task, setTaskState)}
                onPlayClick={() =>
                  handleToggleTracking(
                    task,
                    setTaskTrackingState,
                    updateRecordingTaskInFirestore
                  )
                }
                onStopClick={() =>
                  handleToggleTracking(
                    task,
                    setTaskTrackingState,
                    updateRecordingTaskInFirestore
                  )
                }
              />
            </div>
          ))
        ) : (
          <p>No WIP tasks found.</p>
        )}
      </div>
    </div>
  );
};

export default WipScreen;
